import { RightContext } from './context';
import { useBenefit } from './hooks/useBenefit';
export const RightProvider: React.FC<{
  children: React.ReactNode;
}> = (props) => {
  const provider = useBenefit();
  return <RightContext.Provider value={provider}>{props.children}</RightContext.Provider>;
};
